import { render, staticRenderFns } from "./BaseSvgIcon.vue?vue&type=template&id=21bb39da&scoped=true&"
import script from "./BaseSvgIcon.vue?vue&type=script&lang=js&"
export * from "./BaseSvgIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bb39da",
  null
  
)

export default component.exports